import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { REQUIRED_VALIDATION } from "../../../../helpers/utils/formUtils";
import { MENU_ITEMS } from "../../../../helpers/utils/Constants/menuItems";

export const FaqArray = [
  { id: 1, ...MENU_ITEMS.BUSINESS_ANALYST },
  { id: 2, ...MENU_ITEMS.PRODUCT_OWNER },
  { id: 3, ...MENU_ITEMS.SCRUM_MASTER },
  { id: 15, ...MENU_ITEMS.AI_BUSINESS_ANALYST },
  { id: 4, ...MENU_ITEMS.LANDING_PAGE },
  { id: 5, ...MENU_ITEMS.USER_DASHBOARD },
  { id: 6, ...MENU_ITEMS.PDM },
  { id: 7, ...MENU_ITEMS.SDR },
  { id: 8, ...MENU_ITEMS.CYBER_SECURITY },
  { id: 9, ...MENU_ITEMS.TAC_ICP },
  { id: 10, ...MENU_ITEMS.TAC_ICP_APO },
  { id: 11, ...MENU_ITEMS.TAC_PDM },
  { id: 12, ...MENU_ITEMS.ICP_CERTIFICATION },
  { id: 13, ...MENU_ITEMS.ICP_PDM_CERTIFICATION },
  // { id: 12, ...MENU_ITEMS.SELF_PACED_SCRUM_MASTER },
  // { id: 13, ...MENU_ITEMS.SELF_PACED_PRODUCT_MANAGER },
  // { id: 14, ...MENU_ITEMS.SELF_PACED_AGILE_Project_Manager },
  // { id: 16, ...MENU_ITEMS.SELF_PACED_PRODUCT_MANAGER_LANDING },
  // { id: 17, ...MENU_ITEMS.SELF_PACED_PRODUCT_OWNER_LANDING },
  // { id: 18, ...MENU_ITEMS.SELF_PACED_BUSINESS_ANALYST_LANDING },
  // { id: 19, ...MENU_ITEMS.SELF_PACED_SCRUM_MASTER_LANDING },
];

export const SelfFaqArray = [
  { id: 1, ...MENU_ITEMS.SELF_PACED_SCRUM_MASTER },
  { id: 2, ...MENU_ITEMS.SELF_PACED_PRODUCT_MANAGER },
  { id: 3, ...MENU_ITEMS.SELF_PACED_AGILE_Project_Manager },
  { id: 4, ...MENU_ITEMS.SELF_PACED_PRODUCT_MANAGER_LANDING },
  { id: 5, ...MENU_ITEMS.SELF_PACED_PRODUCT_OWNER_LANDING },
  { id: 6, ...MENU_ITEMS.SELF_PACED_BUSINESS_ANALYST_LANDING },
  { id: 7, ...MENU_ITEMS.SELF_PACED_SCRUM_MASTER_LANDING },
];

export const FAQFilterForTACOnly = [
  { id: 1, ...MENU_ITEMS.ICP },
  { id: 2, ...MENU_ITEMS.ICP_APO },
  { id: 3, ...MENU_ITEMS.PDM },
  { id: 4, ...MENU_ITEMS.APM },
  { id: 5, ...MENU_ITEMS.ICP_ACC },
  { id: 6, ...MENU_ITEMS.ATF },
  { id: 7, ...MENU_ITEMS.SELF_APM },
  { id: 8, ...MENU_ITEMS.LANDING_PAGE },
  { id: 9, ...MENU_ITEMS.SELF_PACED_PDM },
  { id: 10, ...MENU_ITEMS.FAI },
];

const validationSchema = yup.object().shape({
  question: yup.string().required(REQUIRED_VALIDATION("Question")),
  answer: yup.string().required(REQUIRED_VALIDATION("Answer")),
});

export const formOptions: any = {
  resolver: yupResolver(validationSchema),
  mode: "onTouched",
  reValidateMode: "onChange",
};
